import React from "react";
import Select from "react-select";

export default class MultiSelect extends React.Component {
  render() {
    const { disabled, isClearable, name, onChange, options, placeholder, value } = this.props;

    const selection = value ? (
        value.map((valId, index) => ({
            label: (
                options.find(o => o.value === valId) 
                || { label: "" }
            ).label,
            value: valId
        }))
    ) : null;

    return (
      <Select
        className="multiselect"
        closeMenuOnSelect={false}
        disabled={disabled}
        isClearable={isClearable}
        isMulti={true}
        name={name}
        onChange={option => onChange(name, option)}
        options={options}
        placeholder={placeholder}
        value={selection}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/MultiSelect.jsx